import React, { ComponentProps } from 'react';
import { murmurhash } from '../../lib/js/hash';
import { UpcomingEvent } from './partials/UpcomingEvent';
import { ContentList } from '../../_lib/components/ContentList';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { CategoriesListItem } from '../Categories/partials/CategoriesListItem';

export function UpcomingEvents({ events }: { events: UpcomingEvent[] }) {
  const { t } = useSonTranslation('UpcomingEvents');

  if (events && events.length > 0) {
    return (
      <ContentList>
        {events.map(item => (
          <CategoriesListItem
            key={murmurhash(item)}
            style={
              item.categories && item.categories.length > 0
                ? { borderLeftColor: item.categories[0].hexColor }
                : undefined
            }
          >
            <UpcomingEvent {...item} />
          </CategoriesListItem>
        ))}
      </ContentList>
    );
  }

  return <ContentMessage text={t('noContent')} />;
}

export const UpcomingEventsBlock = asBlock(UpcomingEvents, BlockType.upcomingevents);
export type UpcomingEventsBlock = ComponentProps<typeof UpcomingEventsBlock>;
